export const getIntlProvider = state => state.locale.intl;
export const getCurrentLocale = state => state.locale.locale;
